<template>
  <v-card>
    <!-- Delete Dialog -->
    <delete-dialog @success="deleteInvoice" :confirm-loading="deleteConfirmLoading" @closeDialog="cancelDelete"
      :dialog="delete_dialog" title="Invoice">
    </delete-dialog>

    <v-row>
      <v-col sm="5" md="4" lg="4" cols="12 pl-10">
        <router-link :exact="true" :to="{ name: 'AddInvoice' }">
          <v-btn color="#6A158E" dark v-if="perms.pay_add">Create Invoice </v-btn>
        </router-link>
      </v-col>
      <v-col sm="5" md="4" lg="4" offset-lg="4" offset-md="4" offset-sm="2" cols="12 pl-10 pr-10">
        <AccountMonthlySearch @changeYear="searchByYear" @change="searchByMonth" />
      </v-col>
    </v-row>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="mdi-magnify" v-on:keyup.enter="searchRecord" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    
    <!-- <v-data-table :page.sync="page" :items="result_data" :headers="headers"> -->
    <v-data-table :items="result_data" :headers="headers">
    
      
      <template v-slot:item.student_invoice_id="{ item }">
        <span class="table-complete-name">QSL_{{ item[0].student_invoice_id }}</span>
      </template>
      
      <template v-slot:item.student="{ item }">
        <div v-for="stud in item" :key="stud">
          <p v-if="stud != null && typeof stud != 'undefined'">
            {{ stud.student.std_fname +' '+stud.student.std_lname }}
          </p>
        </div>
      </template>
      
      <template v-slot:item.notes="{ item }">
        <div v-for="student in item" :key="student">
          <p v-if="student.notes != null && typeof student.notes != 'undefined'">
            {{ student.notes.substring(0, 20) + ".." }}
          </p>
          <p v-else></p>
        </div>
      </template>
      
      <template v-slot:item.classes="{ item }">
        <div v-for="student in item" :key="student">
          <p>{{ student.class.class_name }}</p>
        </div>
      </template>
      
      <template v-slot:item.total_hours="{ item }">
        <div v-for="student in item" :key="student">
          <p>{{ student.total_hours }}</p>
        </div>
      </template>
      
      <template v-slot:item.created_at="{ item }">
        <p>{{ item[0].created_at }}</p>
      </template>
      
      <template v-slot:item.amount="{ item }">
        <div v-for="student in item" :key="student">
          <p>£ {{ student.amount }}</p>
        </div>
      </template>
      
      <template v-slot:item.paid="{ item }">
        <div v-for="student in item" :key="student">
          <a @click="bindPaid(student)" v-if="student.student_invoice_status != 'processing' && perms.pay_status">
            <v-icon color="red" v-if="student.student_invoice_status == 'unpaid'">
              mdi-checkbox-blank-outline
            </v-icon>
            <v-icon color="green" v-else>mdi-checkbox-marked-outline</v-icon>
          </a>
          <v-icon v-else color="green">mdi-dots-horizontal</v-icon>
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <a :href="`${getBaseURL}/view/invoice/${item[0].student_invoice_id}`" target="_blank">
          <v-icon color="red" v-if="perms.pay_view">mdi-eye</v-icon>
        </a> &nbsp;
        <a :href="`${getBaseURL}/send/invoice/${item[0].student_invoice_id}`" target="_blank">
          <v-icon color="red" v-if="perms.pay_sendInvoice">mdi-send</v-icon>
        </a> &nbsp;
        <v-icon style="cursor: pointer;" @click="confirmDelete(item[0].student_invoice_id)" color="red"
          v-if="perms.pay_remove">mdi-delete</v-icon>
      </template>
    </v-data-table>
    
  </v-card>
</template>

<script>
import DataTableMixin from "../../mixins/dataTable";
import DeleteRow from "../../mixins/deleteRow";
import DeleteDialog from "../Dialogs/DeleteDialog.vue";
import moment from "moment";

export default {
  name: "PaymentTable",
  components: {
    DeleteDialog,
  },
  mixins: [DataTableMixin, DeleteRow],
  computed: {
    getBaseURL(url) {
      return window.baseURL;
    },
  },
  props: {
    perms: {}
  },
  data() {
    return {
      search: "",
      result_data: [],
      url: process.env.VUE_APP_BASE_URL,
      delete_dialog: false,
      page: 1,
      pageCount: 3,
      itemsPerPage: 10,
      permitObj: {},
      headers: [
        {
          text: "Invoice No",
          value: "student_invoice_id",
          sortable: true,
        },
        // {text: "Student ID", sortable: true, value: "student_id"},
        {
          text: "Student Name",
          value: "student",
          sortable: true,
        },
        // {
        //   text: "Notes",
        //   value: "notes",
        //   sortable: false,
        // },
        {
          text: "Class",
          value: "classes",
          sortable: false,
        },
        // {text: "Joining Date", value: "created_at", sortable: false},
        // {text: "Start Date", value: "start_date", sortable: false},
        // {text: "End Date", value: "end_date", sortable: false},
        {
          text: "Total Hours",
          value: "total_hours",
          sortable: false,
        },
        {
          text: "Amount",
          value: "amount",
          sortable: false,
        },
        {
          text: "Created At",
          value: "created_at",
          sortable: false,
        },
        {
          text: "Payment Status",
          value: "paid",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          sortable: false,
        },
      ],
    };
  },
  methods: {

    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },

    GetRows: function () {
      console.log(
        "The row data count is : " + this.$refs.grid.$el.ej2_instances[0].currentViewData
      );
    },

    deleteInvoice() {
      this.deleteConfirmLoading = true;
      axios.post(apiRoutes.accounts.invoices.students.delete, { id: this.current_row })
        .then((response) => {
          this.getItems();
          this.deleteConfirmLoading = false;
          this.delete_dialog = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    bindPaid(row) {
      let temp = row.student_invoice_status;
      // loader
      row.student_invoice_status = "processing";

      axios
        .post(apiRoutes.accounts.invoices.students.status + row.student_invoice_id, {
          status: temp,
        })
        .then((response) => {
          if (response.data.error == false) {
            row.student_invoice_status =
              response.data.status == "paid" ? "paid" : "unpaid";
            this.$emit("created");
          } else {
            row.student_invoice_status = temp;
            alert(response.data.error);
          }
        })
        .catch((error) => {
          row.student_invoice_status = temp;
        });
    },

    getZeroAddedNum(num) {
      return num.toString().padStart(2, "0");
    },

    getItems(month = null, year = null, search=null) {
      this.loading = true;
      axios
        .get(apiRoutes.accounts.invoices.students.url, {
          params: {
            ...this.formQueryParams(),
            month: month,
            year: year,
            search: search ,
          },
        })
        .then((response) => {
          
          this.result_data = [];
          this.$nextTick(() => {
          this.result_data = response.data;
            
          })
          this.loading = false;
        });
    },

    searchByMonth(val) {
      this.getItems(val);
    },

    searchByYear(val) {
      this.getItems(null, val);
    },
    
    searchRecord() {
      this.getItems(null, null , this.search);
    }
    
  },

  mounted() {
    this.getItems();
  },
};
</script>

<style lang="scss">
.v-data-table-header th span {
  font: 300 14px Gotham;
  font-family: "Gotham Narrow";
  color: #8898aa;
}

.table-complete {
  &-srno {
    font: 500 14px/13px Gotham;
    color: #172b4d;
  }

  &-name {
    display: block;
    font: 500 14px/13px Gotham;
    color: #6a158e;
  }

  &-student_id {
    font: 500 14px/13px Gotham;
    color: #0ebddff7;
  }

  &-time {
    display: block;
    font: 400 14px/10px Gotham;
    color: #0e0edff7;
  }

  &-days {
    font: 400 14px/15px Gotham;
    color: #172b4db3;
  }

  &-session {
    font: 500 14px/13px Gotham;
    color: #f0cb00;
  }
}
</style>
